module.exports = __webpack_public_path__ + "static/media/shiyongzu.8b492829.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/trialLease/index/shiyongzu.jpg
// module id = 1206
// module chunks = 0